import Key from '../config/api.config';

function getClarityKey () {
  const { hostname } = window.location;
  let clarityKey;

  switch (hostname) {
    case 'localhost':
    case 'www.localhost':
    case '127.0.0.1':
      clarityKey = Key.clarityKeyDev;
      break;
    case 'dev.themens.com.br':
    case 'www.dev.themens.com.br':
    case 'hml.consultoriomedico.digital':
      clarityKey = Key.clarityKeyDev;
      break;
    case 'themens.com.br':
    case 'www.themens.com.br':
    case 'consultoriomedico.digital':
    case 'www.consultoriomedico.digital':
      clarityKey = Key.clarityKeyProd;
      break;
    default:
      clarityKey = Key.clarityKeyProd;
  }

  return clarityKey;
}

export default getClarityKey;
